import AppConstant from '../config/app.constants';

let ServiceOrderService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstant.api + `/service-order`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = ({ actionCode, actionCodeNotes, branchId, encounterId, locationId, lockType, stopPriority, model, note, serialNumber,requestedTimeframe, status, targetTime, billingReviewRequire, selectedFiles } = {}) => {
        const payload = {
            actionCode: actionCode || null,
            actionCodeNotes: actionCodeNotes || '',
            branchId: branchId || '',
            encounterId: encounterId || '',
            locationId: locationId || '',
            lockType: lockType || '',
            stopPriority: stopPriority || '',
            model: model || '',
            note: note || '',
            requestedTimeframe: requestedTimeframe || '',
            serialNumber: serialNumber || '',
            status: status || '',
            targetTime: targetTime || '',
            billingReviewRequire: billingReviewRequire !== undefined ? billingReviewRequire : false
        };

        const fd = new FormData();

        fd.append('jsonData', JSON.stringify(payload));

        if (selectedFiles && selectedFiles.length) {
            selectedFiles.forEach((file) => {
                if (file._file) {
                    fd.append('files', file._file, file.fileName);
                }
            });
        }

        return $http.post(AppConstant.api + `/service-order`, fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    }

    let getServiceOrder = (branchIds, locationId, routeId, userId, actionCodeId, bucketName, filter, timezone, customerId, serviceZoneId) => {
        return $http
            .post(AppConstant.api + `/service-order/get-service-order`, {
                branchIds,
                locationId,
                routeId,
                userId,
                actionCodeId,
                bucketName,
                filter,
                timezone,
                customerId,
                serviceZoneId
            })
            .then((res) => {
                return res.data
            })
    }

    let serviceOrderHistory = (encounterId, serviceOrderId, externalProcessorId) => {
        return $http
            .post(AppConstant.api + `/service-order/service-order-history`, {
                encounterId,
                serviceOrderId,
                externalProcessorId
            })
            .then((res) => {
                return res.data
            })
    }

    let updateServiceOrderNote = (encounterId, serviceOrderId, branchId, serviceOrderUserNote, serviceOrderNote, vaultDate, routeId, status) => {
        return $http
            .post(AppConstant.api + `/service-order/update-note`, {
                encounterId,
                serviceOrderId,
                branchId,
                serviceOrderUserNote,
                serviceOrderNote,
                vaultDate,
                routeId,
                status
            })
            .then((res) => {
                return res.data
            })
    }

    let updateServiceOrderNoteList = (encounterId, serviceOrderId, branchId, serviceOrderNote, vaultDate, routeId, status, serviceOrderUserNotes) => {
        return $http
            .post(AppConstant.api + `/service-order/update-note-list`, {
                encounterId,
                serviceOrderId,
                branchId,
                serviceOrderNote,
                vaultDate,
                routeId,
                status,
                serviceOrderUserNotes
            })
            .then((res) => {
                return res.data
            })
    }

    let updateServiceOrderStatus = (routeId, status, encounterId, userId, notes, branchId, serviceOrderId, branchVaultDate) => {
        return $http
            .post(AppConstant.api + `/service-order/update-status`, {
                routeId,
                status,
                encounterId,
                userId,
                notes,
                branchId,
                serviceOrderId,
                branchVaultDate
            })
            .then((res) => {
                return res.data
            })
    }

    let branchActiveRouteAndServiceUser = (branchId, vaultDate, timezone) => {
        return $http
            .post(AppConstant.api + `/service-order/branch-active-route-service-user`, {
                branchId,
                vaultDate,
                timezone
            })
            .then((res) => {
                return res.data
            })
    }

    let getRouteStatus = (routeId, vaultDate) => {
        return $http
            .post(AppConstant.api + `/service-order/get-route-status`, {
                routeId,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    }

    let serviceOrderDetails = (userId, routeId, branchId, vaultDate) => {
        return $http
            .post(AppConstant.api + `/service-order/service-order-details`, {
                userId,
                routeId,
                branchId,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    }

    let assignToRouteOrUser = (serviceOrderId, encounterId, userId, routeId, notes, branchId, vaultDate, serviceTicketUserId) => {
        return $http
            .post(AppConstant.api + `/service-order/assign-to-route-or-user`, {
                serviceOrderId,
                encounterId,
                userId,
                routeId,
                notes,
                branchId,
                vaultDate,
                serviceTicketUserId
            })
            .then((res) => {
                return res.data
            })
    }

    let getUserBranchList = (userId) => {
        return $http
            .get(AppConstant.api + `/service-order/get-user-branch-list`, {
                params: {
                    userId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let undoServiceOrder = (status, encounterId, serviceOrderId, branchId, routeId) => {
        return $http
            .post(AppConstant.api + `/service-order/undo-service-order`, {
                status,
                encounterId,
                serviceOrderId,
                branchId,
                routeId
            })
            .then((res) => {
                return res.data
            })
    }

    let getServiceOrderActionCodes = (encounterId) => {
        return $http
            .get(AppConstant.api + `/service-order/get-service-order-action-codes`, {
                params: {
                    encounterId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let markServiceOrderCompleted = (actionCodes, branchId, routeId, serviceOrderId, encounterId, serviceOrderStatusNote, userId, completedByUserId, completedDateTime, arrivedDateTime) => {
        return $http
            .post(AppConstant.api + `/service-order/mark-service-order-completed`, {
                actionCodes,
                branchId,
                routeId,
                serviceOrderId,
                encounterId,
                // serviceOrderNote,
                serviceOrderStatusNote,
                userId,
                completedByUserId,
                completedDateTime,
                arrivedDateTime
            })
            .then((res) => {
                return res.data
            })
    }

    let getServiceUser = (branchId) => {
        return $http
            .get(AppConstant.api + `/service-order/get-service-user`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getCompletedServiceTickets = (locationId, limit, offset, startDate, endDate, timezone, customerId, bucketName, sortASC, sortColumn) => {
        return $http
            .get(AppConstant.api + `/service-order/get-completed-service-tickets`, {
                params: {
                    locationId,
                    limit,
                    offset,
                    startDate,
                    endDate,
                    timezone,
                    customerId,
                    bucketName,
                    sortASC, 
                    sortColumn
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getExternalProcessorCode = (branchId) => {
        return $http
            .get(AppConstant.api + `/service-order/get-external-processor-code`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let transferUnassignedToExternal = (encounterId, externalProcessorCode, branchId, userId) => {
        return $http
            .post(AppConstant.api + `/service-order/transfer-unassigned-to-external`, {
                encounterId, 
                externalProcessorCode,
                branchId,
                userId
            })
            .then((res) => {
                return res.data
            })
    }

    let updateExternalServiceOrderStatus = (status, encounterId, notes, branchId, serviceOrderId, externalProcessorId) => {
        return $http
            .post(AppConstant.api + `/service-order/update-external-service-order-status`, {
                status, 
                encounterId, 
                notes, 
                branchId, 
                serviceOrderId,
                externalProcessorId
            })
            .then((res) => {
                return res.data
            })
    }
    
    let markExternalServiceOrderCompleted = (actionCodes, branchId, routeId, serviceOrderId, encounterId, serviceOrderStatusNote, 
                                             completedByUserId, completedDateTime, externalProcessorId) => {
        return $http
            .post(AppConstant.api + `/service-order/mark-complete-external-service-tickets`, {
                actionCodes, 
                branchId, 
                routeId, 
                serviceOrderId,
                encounterId,
                serviceOrderStatusNote,
                completedByUserId, 
                completedDateTime,
                externalProcessorId
            })
            .then((res) => {
                return res.data
            })
    }

    let validateServiceOrderAssign = (serviceOrderId) => {
        return $http
            .get(AppConstant.api + `/service-order/validate-service-order-assign`, {
                params: { serviceOrderId }
            })
            .then((res) => {
                return res.data
            })
    }

    let resendExternalServiceTickets = (externalProcessorId, serviceOrderId, userId, branchId) => {
        return $http
            .post(AppConstant.api + `/service-order/resend-external-service-tickets`, {
                externalProcessorId, serviceOrderId, userId, branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let getServiceTicketReport = (startDate, endDate, branchId, searchText, locationId, userId, actionCodeId, limit, offset) => {
        return $http
            .get(AppConstant.api + `/service-order/get-service-ticket-report`, {
                params: {
                    startDate, endDate, branchId, searchText, locationId, userId, actionCodeId, limit, offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let printServiceTicketReport = (startDate, endDate, branchId, searchText, locationId, userId, actionCodeId) => {
        return $http
            .get(AppConstant.api + `/service-order/print-service-ticket-report`, {
                params: {
                    startDate, endDate, branchId, searchText, locationId, userId, actionCodeId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportServiceTicketReport = (startDate, endDate, branchId, searchText, locationId, userId, actionCodeId) => {
        return $http
            .post(AppConstant.api + `/service-order/export-service-ticket-report`, {
                startDate, endDate, branchId, searchText, locationId, userId, actionCodeId
            })
            .then((res) => {
                return res.data
            })
    }

    let getLastArrivalTime = (serviceOrderId) => {
        return $http
            .get(AppConstant.api + `/service-order/get-last-arrival-time`, {
                params: { serviceOrderId }
            })
            .then((res) => {    
                return res.data
            })
    }

    let resendServiceTicketAssignment = (encounterId, vaultDate, serviceTicketUserId) => {
        return $http
            .post(AppConstant.api + `/service-order/resend-service-ticket-assignment`, { encounterId, vaultDate, serviceTicketUserId })
            .then((res) => {
                return res.data
            })
    }

    let getServiceOrderImages = (serviceOrderId) => {
        return $http
            .post(AppConstant.api + `/service-order/get-service-order-images`, { serviceOrderId })
            .then((res) => {
                return res.data
            })
    }

    let updateServiceOrderStatusHistory = (id, timestamp, notes, serviceOrderId, isExternal, status, timezone, branchId) => {
        return $http
            .post(AppConstant.api + `/service-order/update-status-history`, {
                id, timestamp, notes, serviceOrderId, isExternal, status, timezone, branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let updateServiceHistory = (history, timezone, branchId) => {
        return $http
            .post(AppConstant.api + `/service-order/update-history`, {
                history, timezone, branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let runAutoAssignNow = () => {
        return $http
            .post(AppConstant.api + `/service-order/run-auto-assign-now`, {})
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        getServiceOrder,
        serviceOrderHistory,
        updateServiceOrderNote,
        updateServiceOrderNoteList,
        updateServiceOrderStatus,
        updateServiceOrderStatusHistory,
        updateServiceHistory,
        branchActiveRouteAndServiceUser,
        getRouteStatus,
        serviceOrderDetails,
        assignToRouteOrUser,
        getUserBranchList,
        undoServiceOrder,
        getServiceOrderActionCodes,
        markServiceOrderCompleted,
        getServiceUser,
        getCompletedServiceTickets,
        getExternalProcessorCode,
        transferUnassignedToExternal,
        updateExternalServiceOrderStatus,
        markExternalServiceOrderCompleted,
        validateServiceOrderAssign,
        resendExternalServiceTickets,
        getServiceTicketReport,
        printServiceTicketReport,
        exportServiceTicketReport,
        getLastArrivalTime,
        resendServiceTicketAssignment,
        getServiceOrderImages,
        runAutoAssignNow
    }
};

ServiceOrderService.$inject = ['$http', '$q'];

export default ServiceOrderService;



// WEBPACK FOOTER //
// ./client/app/services/service-order.service.js